import {UserPic as UserPicDesktop} from '@yandex-lego/components/UserPic/desktop';

export const UserPic = UserPicDesktop;
